import FundUnicefTemplate from '@/page-blocks/about-us/clear/fund/unicef/FundUnicefTemplate';
import ReportUnicef2025 from '@/page-blocks/about-us/clear/fund/unicef/report.unicef_2025';
import { PageProps } from 'gatsby';
import React from 'react';

const FundUnicefIndex: React.FC<PageProps> = (props) => (
  <FundUnicefTemplate year={2025} {...props}>
    <ReportUnicef2025 />
  </FundUnicefTemplate>
);

export default FundUnicefIndex;
